import { Controller } from '@hotwired/stimulus'
import { flash } from '~/utils/show_flash_message.js'

export default class extends Controller {
  static targets = ['confirmationMessage', 'confirmationTemplate']
  static values = {
    content: String,
    flashMessage: String
  }

  copy() {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(this.contentValue).then(() => {
        if (this.hasConfirmationMessageTarget && this.hasConfirmationTemplateTarget)
          this.confirmationMessageTarget.innerHTML = this.confirmationTemplateTarget.innerHTML
      })
    } else {
      // fallback for old browsers or insecure contexts (like HTTP in development)
      const textArea = document.createElement('textarea')
      textArea.value = this.contentValue
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      if (this.hasConfirmationMessageTarget && this.hasConfirmationTemplateTarget)
        this.confirmationMessageTarget.innerHTML = this.confirmationTemplateTarget.innerHTML
    }

    if (this.hasFlashMessageValue) {
      flash({ notice: this.flashMessageValue })
    }
  }
}
